module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-flex', {
    staticClass: "userInfo",
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "historyBox"
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "cellspacing": "10"
    }
  }, [_c('tr', [_c('td', [_c('strong', [_vm._v("TRADING AS:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currentCompany.trading_name))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("VAT NO:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currentCompany.vat_no))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("REGISTRATION NO:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currentCompany.registration_no))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("CONTACT NO:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currentCompany.contact_no))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("FAX NO:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currentCompany.fax_no))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("EMAIL ADDRESS:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currentCompany.email))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("ADDRESS:")])]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncCreateAddress())
    }
  }, [_vm._v(_vm._s(_vm.fncCreateAddress()))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("REGION:")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currentCompany.region))])])])])]), _vm._v(" "), _c('v-layout', {
    staticClass: "pl-4 pr-4 pt-4 pb-4",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    staticClass: "pl-4 pr-1 pb-2 pt-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)])])], 1)], 1)
},staticRenderFns: []}